
const initialState={
    catalogos:{arrayPuestos:[], arrayTabalaUsuariosDS:[]},
};

const reducer = (state = initialState, action )=>{
    switch(action.type){
        case "CAMBIO_PUESTO_EMPADRONAMIENTO_CATALOGO_PUESTOS":
            var catalogoPuestos = Object.assign({}, state);
            catalogoPuestos.catalogos.arrayPuestos= state.catalogos.arrayPuestos.length > 0 ? state.catalogos.arrayPuestos.concat(action.data) : action.data;
            return catalogoPuestos;
        case "CAMBIO_PUESTO_EMPADRONAMIENTO_CATALOGO_USUARIOS_DS":
            var catalogoUsuariosDS = Object.assign({}, state);
            catalogoUsuariosDS.catalogos.arrayTabalaUsuariosDS= state.catalogos.arrayTabalaUsuariosDS.length > 0 ? state.catalogos.arrayTabalaUsuariosDS.concat(action.data) : action.data;
            return catalogoUsuariosDS;
        default:
            return state;
    }
}

export default reducer;